export default {"src":"/_next/static/media/learning-logo.43a780e6.svg","height":38,"width":215,"blurWidth":0,"blurHeight":0};